// extracted by mini-css-extract-plugin
export var download = "styles-module--download--b9af7";
export var image = "styles-module--image--3f076";